import { render, staticRenderFns } from "./currency.vue?vue&type=template&id=2e41e6bc&"
import script from "./currency.vue?vue&type=script&lang=ts&"
export * from "./currency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports